<template>

  <div class="word_upload" >
    <!-- v-if="fileMenuIsMust" -->
    <!-- {{fileMenuIsMust}} -->
    <!--   action="/api/file/addFileByOtherId" --> 
     
    <el-upload
      :data="Id !='' && baFileMenuId != undefined?editDate:uploadData"
      :headers="uploadHeaders" 
       :action="Id !='' && baFileMenuId != undefined ?'/api/file/editFileByOtherId':'/api/file/addFileByOtherId'"
      multiple 
      :show-file-list="false" 
      :on-progress="uploadProgress"
      :on-change="handleChange"
      :on-success="handsuccess"
      :on-error="uploadFileError"
      :before-upload="beforeUpload"
    >
      <el-button
        type="text"
        v-if="showButton"
        :icon="[
          Id != '' && baFileMenuId != undefined
            ? 'el-icon-refresh'
            : 'el-icon-upload'
        ]"
      >
        {{ Id != "" && baFileMenuId != undefined ? "替换" : "上传" }}</el-button
      >
      
    </el-upload>
    
  </div>
</template>

<script>
import Cookies from "js-cookie";
// import * as api from "@/api/text/text";
import { mapGetters } from "vuex";
export default {
  name: "wordUpload",
  data() {
    return {
      onloadloading:false,
      progressFlag: false,
      uploadPercent: 0,
      uploadNum: 0,
      filesLength: 0,
    };
  },
  computed: {
    ...mapGetters(["workFlowState"]),
    //  流程未发起时 或者流程已经发起 但是在第一步的时候可以修改附件 
    showButton() {
      // 流程第一步可上传附件
      if(this.workFlowState.state 
        && ((this.workFlowState.state == 1 && !this.workFlowState.isFirstFlowPermission) 
          || this.workFlowState.state == 2
        ) 
      ){
        return false
      } else {
        return true
      }
    },
    uploadHeaders() {
      return {
        "Blade-Auth": "bearer " + Cookies.get("saber-access-token")
      };
    },
    uploadData() {
      return {
        baFileMenuId: this.Id,
        fileOtherId: this.batchFile?this.dynamicId:this.projectid,
        fileDynamicId:this.batchFileUpload?this.projectid:this.fileDynamicId==-1?this.dynamicId==-1?'':this.dynamicId:this.fileDynamicId
      };
    },
    editDate(){
      return {
        id:this.filesid,
        fileOtherId:this.batchFile?this.dynamicId:this.projectid,
        baFileMenuId:this.baFileMenuId,
        fileDynamicId:this.batchFileUpload?this.projectid:this.fileDynamicId==-1?this.dynamicId==-1?'':this.dynamicId:this.fileDynamicId
        // fileDynamicId:this.fileDynamicId==-1?'':this.fileDynamicId

      }
    },
    

  },
  created() { 
    // console.log(this.PageId,this.baFileMenuId,this.Id)
  },
  props: ["baFileMenuId", "PageId", "Id", "fileMenuIsMust", "projectid",'filesid','dId','dynamicId','fileDynamicId',"batchFileUpload", "batchFile"],


  methods: {
    beforeUpload(files){
      // if(!this.baFileMenuId){
      //   this.$message.error("请先选择项目名称")
      //   return 
      // }
      this.filesLength=this.filesLength+1
      
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    uploadProgress(event, file, fileList) {
      let max = Math.max.apply(
        Math,
        fileList.map(function (value) {
          return value.size;
        })
      );
      if (file.size == max) {
        
        this.uploadPercent = Math.floor(event.percent);
        if (this.uploadPercent == 100) {
          this.uploadPercent = 99;
        }
        this.$emit("uploadProgress", this.uploadPercent, true);
      }
      
    },
    handsuccess(file, fileList) {
      
      let that=this
      this.uploadNum = this.uploadNum + 1;
      if (that.uploadNum == that.filesLength) {
        that.uploadNum = 0;
        that.filesLength=0
        that.$emit("update", true);
      }
      
      
    },
    uploadFileError(){
      this.$emit("uploadProgress", 0, false);
      this.$message.error("上传失败！")
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log("handlePreview");
    },
    beforeupload(file){
      // console.log("----beforeupload------")
      // console.log(file)

    },
    // handleChange(file, fileList) { 
    //   this.$emit("uploading",true)
    //   // console.log("----handleChange------")
    // },
    onprogress(event, file, fileList){
      // console.log("mo___onprogress")
      // this.$emit("yesloading",false)
      // console.log(event, file, fileList)
    },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // }
  }
};
</script>

<style lang="less" scoped></style>
